import styled, { css, keyframes } from "styled-components";
import theme from "styled-theming";
import { device } from "../styles/Reset";
import { MEDIA_URL } from "static-content/RelativeUrlHelperFunctions";

const fadeIn = keyframes`
  from {transform: scale(.25);opacity: 0;}
  to {transform: scale(1) translate(-50%, -50%);opacity: 1;}
`;

const fadeInMobile = keyframes`
  from {transform: scale(.25);opacity: 0;}
  to {transform: scale(1) ;opacity: 1;}
`;

const bottomClient = theme("badgesLayout", {
  standalone: css`
    border-top: 2px solid #444;
    background: #f2f9fb;
    padding: 8px 20px;
    margin: 0 auto;
    border-radius: 0;
  `,
  contained: css`
    transform: skew(-8deg);
  `,
});

const fullscreenBgClient = theme("badgesLayout", {
  contained: "linear-gradient(0deg, #a9e3f0 0, #5ccae2)",
});

const buttonCloseWrapperClient = theme("badgesLayout", {
  contained: css`
    margin-top: 0;
  `,
});

const buttonCloseWrapperClientLarge = theme("badgesLayout", {
  contained: css`
    min-width: 110%;
    margin-top: 10px;
  `,
});

const modalBgClient = theme("badgesLayout", {
  contained: "transparent",
});

const HeadingStyleClient = theme("badgesLayout", {
  contained: css`
    color: #fff;
  `,
});

const SubheadingStyleClient = theme("badgesLayout", {
  contained: css`
    color: #fff;
    max-width: 60%;
    margin: 15px auto;
  `,
});

const buttonCloseClient = theme("badgesLayout", {
  standalone: css`
    color: #aaa;
    font-weight: normal;
  `,
  contained: css`
    color: #fff;
  `,
});

const buttonClient = theme("badgesLayout", {
  contained: css`
    border-bottom: 2px solid #562894;
  `,
});

const modalLargeClient = theme("badgesLayout", {
  contained: css`
    padding-right: 40px;
  `,
});

const modalSpecialLooksClientLarge = theme("badgesLayout", {
  contained: css`
    left: -30px;
    transform: skew(-8deg);
    min-width: 110%;
  `,
});

const modalSpecialLooksClient = theme("badgesLayout", {
  contained: css`
    min-width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    display: block;
    z-index: -1;
    content: " ";
    opacity: 0.96;
    background: #4e70c1};
  `,
});

export const ModalContainer = styled.div`
  position: fixed;
  bottom: 0;
  top: 0;
  right: 0;
  left: 0;
  margin: auto;
  overflow-y: auto;
  height: 300px;
  z-index: 3650;
  padding: 5px 15px 20px 15px;
  width: 100%;
  max-width: 300px;
  text-align: center;
  border-radius: 15px;
  background-color: #fff;
  background-color: ${modalBgClient};
  animation: ${fadeInMobile} 0.5s ease-in-out;
  animation-fill-mode: both;
  transform-origin: left top;
  &.nav {
    top: auto;
    height: auto;
    border-radius: 20px 20px 0 0;
    width: 100%;
    max-width: 100%;
    z-index: 3595;
  }
  &.withNav,
  &.long {
    animation: none;
  }
  &.long {
    height: 450px;
  }
  &::before {
    ${modalSpecialLooksClient};
  }
  &.fullscreen::before,
  &.bottom::before {
    display: none;
  }
  &.celebration {
    max-height: 350px;
  }
  &.fullscreen {
    height: 100%;
    width: 100%;
    max-width: none;
    overflow-y: scroll;
    border-radius: 0;
    padding: 50px 15px 15px 15px;
    background: ${fullscreenBgClient};
  }

  &.bottom {
    bottom: 0;
    top: auto;
    width: 100%;
    max-width: 100%;
    max-height: none;
    min-height: 80px;
    height: auto;
    background-color: #eae9e9;
    padding: 8px;
    padding-left: 80px;
    padding-top: 8px;
    text-align: left;
    margin: 14px auto;
    opacity: 0.95;
    border-radius: ${(props) => props.theme.themeGlobal.borderRadiusSecondary};
    animation: none;
    animation-fill-mode: both;
    transform-origin: initial;
    left: 0;
    margin-bottom: 0;
    background-image: url(${MEDIA_URL}/common/cookie-icon.png);
    background-repeat: no-repeat;
    background-size: 60px;
    background-position: 10px 30px;
    ${bottomClient};
  }
  &.HEADER_OVERFLOW {
    overflow-y: visible;
  }

  &.configurePrivacy {
    height: 90%;
    animation: none;
    transform: none;
    transform-origin: initial;
  }

  > a {
    color: ${(props) => props.theme.themeGlobal.main};
    &:visited {
      color: ${(props) => props.theme.themeGlobal.main};
    }
  }
  @media ${device.landscape} {
    &.nav {
      border-radius: 0;
      height: 90%;
    }
  }

  @media ${device.laptop} {
    position: fixed;
    top: 50%;
    left: 50%;
    box-sizing: border-box;
    width: 400px;
    max-width: 400px;
    max-height: auto;
    height: auto;
    background: #fff;
    right: auto;
    bottom: auto;
    animation: ${fadeIn} 0.5s ease-in-out;
    animation-fill-mode: both;
    transform-origin: left top;
    &.withNav,
    &.long {
      animation: none;
      transform: translate(-50%, -50%);
    }
    &.long {
      height: 500px;
    }
    &::before {
      ${modalSpecialLooksClientLarge};
    }
    &.fullscreen {
      background-position: left center;
      font-size: 1.2rem;
      transform: none;
      animation: none;
      transform-origin: initial;
      left: 0;
      top: 0;
    }
    &.nav {
      top: 50%;
      height: auto;
      border-radius: 15px;
      width: 400px;
      max-width: 400px;
      z-index: 3500;
    }
    &.bottom {
      background-position: 25px center;
      padding-top: 8px;
    }
    &.configurePrivacy {
      max-width: 600px;
      width: 600px;
      padding: 0;
      animation: none;
      transform: none;
      animation-fill-mode: both;
      transform-origin: initial;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      max-height: 510px;
      border: 1px solid #e7e8e7;
    }
  }
`;

export const Label = styled.label`
  display: block;
  text-align: left;
  font-weight: bold;
  margin: 5px auto;
  font-size: 12px;
  color: ${(props) => props.theme.themeGlobal.main};
`;

export const ModalBody = styled.div`
  position: relative;
  background: ${modalBgClient};
  max-width: 300px;
  margin: 0 auto;
  > h2 {
    margin-top: 5px;
    padding: 0 5px;
    text-align: center;
  }

  > .required {
    color: #82134f;
    font-weight: bold;
    margin: 5px auto;
    font-size: 12px;
  }
  &.fullscreen {
    margin: 0 auto;
  }
  &.bottom {
    max-width: 100%;
  }

  @media (min-width: 600px) {
    &.fullscreen {
      max-width: 600px;
    }
    &.bottom {
      padding: 5px 15px 0 10px;
    }
    &.nav {
      margin: 0 auto;
    }
  }
  @media ${device.laptop} {
    max-width: 400px;
    &.bottom {
      display: inline-block;
      max-width: 100%;
      background: ;
    }
    &.configurePrivacy {
      max-width: 100%;
    }
  }
`;

export const Heading = styled.h3`
  color: ${(props) => props.theme.themeGlobal.headingColor};
  padding-top: 0;
  ${HeadingStyleClient}
  &.success {
    margin: 80px auto;
  }

  @media only screen and (max-width: 1024px) and (orientation: landscape) {
    font-size: 1.5rem !important;
  }
`;

export const Subheading = styled.p`
  ${SubheadingStyleClient}
`;

export const ButtonLink = styled.a`
  display: block;
  width: 100%;
  min-width: 130px;
  max-width: 250px;
  margin: 5px auto;
  padding: 12px 10px;
  text-decoration: none;
  color: #fff;
  background-color: ${(props) => props.theme.themeGlobal.secondary};
  border-radius: ${(props) => props.theme.themeGlobal.borderRadiusSecondary};
  ${buttonClient};
  &:hover {
    opacity: 0.8;
  }
`;

export const Button = styled.button`
  width: 100%;
  color: #fff;
  padding: 12px 10px;
  background-color: ${(props) => props.theme.themeGlobal.main};
  border: 2px solid ${(props) => props.theme.themeGlobal.main};
  border-radius: ${(props) => props.theme.themeGlobal.borderRadiusSecondary};
  margin-bottom: 5px;
  &.inverse {
    border: 2px solid ${(props) => props.theme.themeGlobal.main};
    color: ${(props) => props.theme.themeGlobal.main};
    background: transparent;
    font-weight: normal;
  }
  &.smallButton {
    min-width: 180px;
    width: auto;
    margin-right: 5px;
    padding: 8px 5px;
    font-size: 1.4rem;
  }
  &.extraSmallButton {
    min-width: 0;
    width: auto;
    padding: 8px;
    font-weight: normal;
  }
  &.right {
    float: right;
  }
  &.center {
    margin: auto;
    display: block;
    margin-top: -5px;
  }
  ${buttonClient};
`;

export const ButtonCloseWrapper = styled.div`
  text-align: left;
  ${buttonCloseWrapperClient};

  @media ${device.laptop} {
    text-align: right;
    ${buttonCloseWrapperClientLarge};
    &.fullscreen {
      position: fixed;
      min-width: 100%;
      right: 50px;
      top: 60px;
    }
  }
`;
export const ButtonClose = styled.button`
  width: 44px;
  padding: 0;
  text-align: center;
  font-size: 4rem;
  color: #aaa;
  font-weight: normal !important;
  ${buttonCloseClient};
`;

export const Paragraph = styled.p`
  margin: 20px auto;
  text-align: center;
  max-width: 80%;
`;

export const BackDrop = styled.div`
  content: " ";
  position: fixed;
  display: block;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 3040;
  background-color: #000;
  opacity: 0.75;
  &.nav {
    z-index: 3590;
    opacity: 0.9;
  }
  @media ${device.laptop} {
    &.nav {
      z-index: 3040;
      opacity: 0.85;
    }
  }
`;

export const Page = styled.div`
  display: ${(props) => (props.visible ? "block" : "none")};
  min-height: 200px;
  > h2 {
    font-size: 1.6rem;
    text-transform: uppercase;
    text-align: center;
    padding: 0;
    margin: 0;
  }
  > p {
    text-align: left;
    font-size: 1.3rem;
    padding: 15px 10px;
  }
  @media ${device.landscape} {
    > p {
      padding: 3px 10px;
      text-align: center;
      max-width: 350px;
      margin: 0 auto;
    }
  }
  @media ${device.laptop} {
    min-height: 250px;
    > h2 {
      font-size: 2.1rem;
    }
    > p {
      text-align: left;
      padding: 15px 10px;
    }
  }
`;
export const Nav = styled.div`
  text-align: center;
  margin: 10px auto 0 auto;
  position: relative;
  max-width: 140px;
  @media ${device.laptop} {
    cursor: pointer;
  }
`;

export const Bullet = styled.div`
  height: 20px;
  width: 20px;
  border-radius: 50%;
  display: inline-block;
  margin: 0 5px;
  background: #ccc;
  margin-top: 3px;
  background: transparent;
  border: 3px solid #ccc;
  &.active {
    background: ${(props) => props.theme.themeGlobal.main};
    border: none;
  }
  @media ${device.laptop} {
    height: 8px;
    width: 8px;
    &.active {
      margin-top: 0;
      height: 15px;
      width: 15px;
    }
  }
`;

export const PagesContainer = styled.div`
  min-height: 150px;
`;

export const NavArrow = styled.span`
  position: absolute;
  bottom: 0;
  right: 0;
  left: ${(props) => (props.direction === "left" ? 0 : "auto")};
  height: 100%;
  width: 40px;
  display: inline-block;

  &::after {
    content: ${(props) => (props.direction === "right" ? `"›"` : `"‹"`)};
    height: 100%;
    width: 40px;
    font-size: 3rem;
    line-height: 2rem;
    display: inline-block;
    font-weight: normal;
    color: #737272;
    overflow: hidden;
  }

  @media ${device.laptop} {
    &::after {
      line-height: 1rem;
    }
  }
`;
